import { ref, unref, MaybeRef } from 'vue';
import { Maybe } from '@/src/types';
import { vec3 } from 'gl-matrix';
import type { Vector2 } from '@kitware/vtk.js/types';

import { useSliceConfig } from '@/src/composables/useSliceConfig';


class DynTimer {
  private counter: number = 0;
  private timerId: number | undefined;

  private range: Vector2 = [0,100];
  private looping: boolean = false;

  constructor(beginTimer: number, endTimer: number, isLooping?: boolean) {
    this.range = [beginTimer, endTimer];
    this.looping = isLooping ?? false;
    this.counter = this.range[0];
  }

  setLooping(isLooping: boolean) {
    this.looping = isLooping;
  }

  setCounter(count: number)
  {
    this.counter = count;
  }

  // Method to start the timer
  startTimer(stepCallback: () => void, resetCallback: (slId: number) => void, isLooping?: boolean) {
    if(this.timerId === undefined)
    {
      this.looping = isLooping ?? this.looping;

      this.timerId = window.setInterval(() => {
        if(this.counter < this.range[1])
        {
          this.counter++;
          stepCallback();
        }
        else
        {
          if(this.looping)
          {
            this.counter = this.range[0];
            resetCallback(this.counter);
          }
          else
            this.stopTimer();
        }
      }, 750); // Update every 1000 ms (1 second)
    }
  }

  // Optionally, stop the timer
  stopTimer() {
    if (this.timerId !== undefined) {
      clearInterval(this.timerId);
      this.timerId = undefined;
    }
  }
}


export function useDynSliceController(
  viewID: MaybeRef<string>,
  imageID: MaybeRef<Maybe<string>>
) {

  const { slice: currentSlice, range: sliceRange } = useSliceConfig(viewID, imageID);

  const timer = new DynTimer(unref(sliceRange)[0], unref(sliceRange)[1]);

  function incrementSlice(): void {
    currentSlice.value += 1;
  };

  function setSlice(slId: number): void {
    currentSlice.value = slId;
  };

  function startScrolling(isLooping?: boolean) {
    timer.startTimer(incrementSlice, setSlice, isLooping);
  }
  function stopScolling() {
    timer.stopTimer();
  }

  function setLoopingParam(isLooping: boolean) {
    timer.setLooping(isLooping);
  }
  function setSliceParam(count: number)
  {
    timer.setCounter(count);
  }


  return { startScrolling, stopScolling, setLoopingParam, setSliceParam };
}
